module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Part-I.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "PL-Title-Page-Dividing-Line-4"
  }, [_c('p', {
    staticClass: "ch-part"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Part I")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "pl-header-part"
  }, [_vm._v("Ambition, Art, Passion")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("We knew very well that we were damned,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("But hope of love along the way")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Made both of us think")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Of what the Gypsy did prophesy.")]), _vm._v(" "), _c('p', {
    staticClass: "citation"
  }, [_vm._v("—Guillaume Apollinaire")])])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a79a0a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartI.vue
// module id = 69
// module chunks = 0